// extracted by mini-css-extract-plugin
module.exports = {"linkItem":"_1uvzW9N"};